<main [class.with-top-bar]="showTopBar()">
  @if (showTopBar()) {
    <app-top-bar></app-top-bar>
  }
  <div class="outlet-content">
    <router-outlet></router-outlet>
  </div>
</main>
